import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	exit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	exit: {
		id: 'project-directory-onboarding-modal.label.exit',
		defaultMessage: 'Exit',
		description: 'Label for pressing on the cross button of the modal',
	},
});
export default messages;
